<template>
    <div>
        <h1>
            <el-page-header @back="goBack" content="Icon图标管理"></el-page-header>
        </h1>
        <el-card class="form-container" shadow="never">
            <el-button class="sub-sub" type="primary" @click="showDetails('创建图标')">创建</el-button>
        </el-card>
        <h1>
            <el-table :data="icons"
                      border
                      :fit="true">
                <el-table-column label="图标ID" prop="id" align="center"></el-table-column>
                <el-table-column  label="图标图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间"  prop="createDt" :formatter="formatDate" align="center"></el-table-column>
                <el-table-column label="修改时间"  prop="updateDt" :formatter="formatDate" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showDetails('编辑图标',scope.row)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-form :model="addIconForm">
                <el-form-item label="图标图片 :" :label-width="labelWidth">
                    <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleImageSuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadImage">
                        <img v-if="addIconForm.image" :src="VUE_APP_CDN_URL+addIconForm.image" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm" >提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import {
        upload,
        searchIcon,
        saveIcon,
        deleteIcon
    } from "@/http/iosApi";
    import utils from '@/utils';
    export default {
        name: "Icon",
        data(){
            return{
                VUE_APP_IOS_URL:'',
                VUE_APP_CDN_URL:'',
                headers:{},
                dialogVisible:false,
                dialogTitle:'',
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                icons:[],
                labelWidth: '110px',
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                addIconForm: {
                    id: 0,
                    image:''
                },
                queryData:{}
            }
        },
        methods:{
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            goBack(){
                this.$router.push({path: '/iconCategory'})
            },
            showDetails(title,data){
                if (data){
                    this.addIconForm= {
                        id: data.id,
                        image: data.image
                    }
                }else {
                    this.addIconForm= {
                        id: 0,
                        image:''
                    }
                }
                this.dialogTitle  = title;
                this.dialogVisible = true;
            },
            uploadImage(){
                let func = upload;
                func().then().catch(function () {
                })
            },
            handleImageSuccess(response){
                this.addIconForm.image=response.info;
            },
            handleImageLineSuccess(response){
                this.addIconForm.imageLine=response.info;
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteIcon(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search()
                        }
                    });
                }).catch(() => {
                })
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            confirmForm(){
                let _message = '';
                if (this.addIconForm.image===''){
                    _message = '请上传图片'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                 saveIcon(this.addIconForm).then(resp => {
                     if (resp.data.status === 0 ){
                         this.search()
                         this.dialogVisible = false;
                     }
                 });
            },

            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            search(){
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                searchIcon(this.queryData).then(resp=>{
                    this.icons= resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },

        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.search();
        },
        mounted() {
            this.VUE_APP_IOS_URL=process.env.VUE_APP_IOS_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>